// const Url = 'http://127.0.0.1:8000'
const Url = 'https://panjwanitutorials.com'
const themeDefault = 'dark'
const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']


export { Url, themeDefault, namesOfModes}